import { TeamDO } from "./TeamDO";

export class Student {
	/**unique student name for this machine*/
	public name:string;
	/**defaults to null if no code is provided*/
	public teamCode:string;
	/**defaults to null if no code is provided*/
	public teamName:string;
	/**Map of songLibId/percentage score pairs*/
	public scores:Map<string, number>;
	
	/**not stored in local storage - populated for convenience */
	public team:TeamDO;
	
	/**updates a score for the student if the new score is higher*/
	public updateScore(songLibId:string, score:number):void {
		let oldScore:number = this.scores.get(songLibId)?? 0;
		if (score > oldScore && score > 0){
			this.scores.set(songLibId, score);
		}
	}
	
	public parseScores(scoresJson:any):void {
		this.scores = new Map<string, number>();
		let keys = Object.keys(scoresJson);
		keys.forEach((k) => {
			this.scores.set(k, scoresJson[k]);
		});
	}
	
	public getScoresMapAsObject():any {
		let obj = {};
		let keys = this.scores.keys();
		for (let key of keys){
			obj[key] = this.scores.get(key);
		}
		return obj;
	}
}